/* =========================================================
   ALS BIKES THEME
   Mobile Footer Accordion
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const footerMenus = document.querySelectorAll(
    '.footer .footer-block--menu'
  );

  footerMenus.forEach(function (menu) {

    const heading = menu.querySelector(
      '.footer-block__heading'
    );

    if (!heading) return;

    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    function toggleMenu() {

      if (window.innerWidth >= 750) return;

      const isOpen =
        menu.classList.toggle('als-footer-open');

      heading.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
    }

    heading.addEventListener('click', toggleMenu);

    heading.addEventListener('keydown', function (event) {

      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();
        toggleMenu();
      }

    });

  });

});